module.exports = __webpack_public_path__ + "img/top_logo_phone.2d8e32fc.png";